<div [class.loader-hidden]="!show">

    <div id="loader-overlay">
        <div class="background"></div>
        <img id="center" style="width: 300px;" [src]="'assets/images/logos/logo_ezycharge_main.png'" alt="assets/images/logos/logo_ezycharge_main.png">
    </div>
</div>